import React from 'react';
import Icon from '@mdi/react';
import i18next from 'i18next';

import { toCSSColor } from '../../utils';
import { TextField } from '@mui/material';
import { ReduxUpdater } from '../../pdf/ReduxUpdater';

export default class Command {
    public readonly Enabled?: boolean;
    public readonly Icon?: JSX.Element;
    public readonly IconColor?: string;
    public readonly IconBackgroundColor?: string;
    public readonly Key: string;
    public readonly Path: string | false;
    public readonly Text?: string;
    public readonly StateName?: string;
    public readonly OpenContextMenu?: boolean;
    public readonly Callback: () => void;

    constructor(config: ICommandConfig) {
        this.Enabled = config.Enabled ?? true;
        this.Icon = config.Icon;
        this.IconColor = config.IconColor;
        this.IconBackgroundColor = config.IconBackgroundColor;
        this.Key = config.Key;
        this.Path = config.Path;
        this.Text = config.Text;
        this.StateName = config.StateName;
        this.OpenContextMenu = config.OpenContextMenu;
        this.Callback = config.Callback;
    }

    /**
     * Gets the translated element name.
     */
    public GetTitle = (): string => this.Text ?? i18next.t(`command.title.${this.Key}`);
    public GetHint = (): string => i18next.t(`command.hint.${this.Key}`);
    public HasHint = (): boolean => i18next.exists(`command.hint.${this.Key}`);
    public GetShortcut = (): string =>
        i18next.exists(`shortcut.${ReduxUpdater.shortcuts[this.Key]}`)
            ? i18next.t(`shortcut.${ReduxUpdater.shortcuts[this.Key]}`)
            : ReduxUpdater.shortcuts[this.Key] ?? '';
    public GetUniqueKey = (): string => `${this.Key}-${Math.floor(Math.random() * 10000)}`;
    public GetIcon = (): JSX.Element | null => {
        const containerStyles: React.CSSProperties = {
            backgroundColor: this.IconBackgroundColor ?? 'none',
            borderRadius: '4px',
        };
        if (this.Icon) {
            return <div style={{ ...containerStyles, color: this.IconColor ?? toCSSColor(0), display: 'flex' }}>{this.Icon}</div>;
        }
        if (this.Path) {
            // Use @mdi/react color prop directly — sets fill on <path> as inline style,
            // which beats any CSS fill rules including !important on the parent <svg>.
            return <Icon
                path={this.Path}
                color={this.IconColor ?? undefined}
                style={containerStyles}
            />;
        }
        return null;
    };
}

export interface ICommandConfig {
    Enabled?: boolean;
    Icon?: JSX.Element;
    IconColor?: string;
    IconBackgroundColor?: string;
    Key: string;
    Path: string | false;
    Text?: string;
    StateName?: string;
    OpenContextMenu?: boolean;
    Callback: () => void;
}

export const renderReadOnlyPropertyRow = (key: string, title: string, value: string) => {
    return (
        <TextField
            fullWidth
            key={key}
            label={title}
            value={value}
            variant="standard"
            margin="normal"
            InputProps={{
                readOnly: true,
            }}
            InputLabelProps={{
                shrink: true,
            }}
        />
    );
};
